module.exports = __webpack_public_path__ + "static/img/01.5c8b4a64.png";